import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Card, Image as SemanticImage } from 'semantic-ui-react';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import md5 from 'md5';
import Button from "@mui/material/Button";
import AspectsList from 'app/components/AspectsList';

import UploadFile from './UploadFile';
import classes from 'app/components/Modal/classes.module.scss';

import {
  getProductBackgrounds,
  createProductBackground,
  uploadProductAsset,
  deleteProductBackground,
  deleteBackgroundAspect
} from 'app/actions/jobConfigs';

import {
  updateMoment
} from 'app/services/moments';

const BackgroundList = (props) => {
  const {
    isOpen,
    selectedJobConfig,
    getProductBackgrounds,
    createProductBackground,
    uploadProductAsset,
    onClose,
    deleteProductBackground,
    deleteBackgroundAspect,
    account
  } = props;

  const [loaded, setLoaded] = useState(false);
  const [backgrounds, setBackgrounds] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isAspectDialogVisible, setIsAspectDialogVisible] = useState(false);

  let boxClass = classes.paper,
    boxStyle = { maxWidth: "960px" },
    headerVariant = 'h5';

  useEffect(() => {
    if (!loaded) {
      getProductBackgrounds(account.id, selectedJobConfig.product_id).then((results) => {
        const _result = Object.assign([], results);
        _result.splice(0, 0, { id: 0 });
        setBackgrounds(_result);
        setLoaded(true);
      })
    }
  }, [loaded])

  const loadedAspects = async (id) => {
    const backgrounds = await getProductBackgrounds(account.id, selectedJobConfig.product_id);
    const selectedBackground = backgrounds.find(bg => bg.id === id);
    if (selectedBackground) {
      return selectedBackground.aspects;
    }
    return [];
  }

  const handleBackgroundChange = (event, backgroundId) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (file) {
        const hashCallback = function (hash) {
          file.hash = hash;
          const dimensionCallback = function (file) {
            let bgFile = {
              name: file.name,
              size: file.size,
              type: file.type,
              hash: file.hash,
              width: file.width,
              height: file.height
            };

            createProductBackground(account.id, selectedJobConfig.product_id, [bgFile], backgroundId).then(async (result) => {
              for (var bg of result.aspects) {
                if (bg.hash == file.hash) {
                  await uploadProductAsset(bg.moment_id, file.type, file);
                  await updateMoment(bg.moment_id, { id: bg.moment_id, uploaded: new Date().toISOString() });
                }
              }
              alert('Background uploaded successfully');
              setLoaded(false);
            })
          }
          getImageDimension(file, dimensionCallback);
        }
        createHash(file, hashCallback);
      }
    }
  }

  const getImageDimension = (file, callback) => {
    var image = new Image();
    image.onload = function () {
      file.width = image.width;
      file.height = image.height;
      callback(file);
    }
    image.src = URL.createObjectURL(file);
  }

  const createHash = (file, callback) => {
    var fr = new FileReader();

    fr.onload = function () {
      return callback(md5(fr.result));
    }

    fr.readAsBinaryString(file);
  }

  const handleDelete = async (id) => {
    const deleteMsg = "Are you sure you want to remove this background? It will be removed from this product";
    if (window.confirm(deleteMsg) === true) {
      await deleteProductBackground(account.id, selectedJobConfig.product_id, id).then(() => {
        setLoaded(false);
      })
    }
  }

  const handleViewAspects = (bg) => {
    setSelectedItem(bg);
    setIsAspectDialogVisible(true);
  }

  return <div>
    <Modal open={isOpen} className={classes.modal} onClose={onClose}>
      <Box className={boxClass} style={boxStyle}>
        <CloseIcon className={classes.closeIcon} onClick={onClose} />
        <Typography variant={headerVariant} className={classes.formTitle}>
          Manage Backgrounds
        </Typography>
        <span>
        </span>
        <hr />
        <div>
          <Card.Group key='id'>
            {
              backgrounds && backgrounds.map((bg, index) => {
                if (bg.id === 0) {
                  return <Card key={index}>
                    <Card.Content>
                      <div className={classes.upload}>
                        <UploadFile onFileChange={(e) => { handleBackgroundChange(e, 0) }} />
                      </div>
                    </Card.Content>
                  </Card>
                }
                return <Card key={index}>
                  <Card.Content>
                    <SemanticImage src={bg.url} wrapped ui={true} />
                  </Card.Content>
                  <Card.Content extra textAlign='center'>
                    <Button fullWidth variant="contained" onClick={() => { handleViewAspects(bg) }}>View Aspects</Button>
                  </Card.Content>
                  <Card.Content extra textAlign='center'>
                    <div className='ui two buttons'>
                      <Button fullWidth variant="contained" component="label">
                        <input
                          type="file"
                          accept={props.acceptedTypes || 'image/*'}
                          hidden
                          onChange={(e) => handleBackgroundChange(e, bg.id)}
                        />
                        Add Size</Button>
                      <Button fullWidth variant="contained" onClick={() => handleDelete(bg.id)}>Remove</Button>
                    </div>
                  </Card.Content>
                </Card>
              })
            }
          </Card.Group>
        </div>
      </Box>
    </Modal>
    {
      isAspectDialogVisible &&
      <AspectsList isOpen={true}
        onClose={() => { setIsAspectDialogVisible(false); }}
        title='Background Aspects'
        type='background'
        getData={loadedAspects} selectedItem={selectedItem}
        addSize={handleBackgroundChange}
        jobConfig={selectedJobConfig}
        onDelete={deleteBackgroundAspect}
      />
    }
  </div>
}

const mapStateToProps = state => ({
  darkMode: state.portalReducer.darkMode,
  account: state.portalReducer.account
});

export default connect(mapStateToProps, { uploadProductAsset, getProductBackgrounds, createProductBackground, deleteProductBackground, deleteBackgroundAspect })(BackgroundList);
